export default {
  container: "swal-custom-container",
  title: "swal-custom-title",
  confirmButton: "swal-custom-action-confirm",
  htmlContainer: "swal-custom-html-container",
};
